export default __webpack_public_path__ + "static/media/concierge.b9989971.svg";